export default "__VITE_ASSET__e555fb18__"